'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Copyright 2013-2015, Hudl
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule MediaEventConstants
 */

exports.default = {
  abort: 'abort',
  adBegan: 'adbegin',
  adEnded: 'adended',
  canPlay: 'canplay',
  canPlayThrough: 'canplaythrough',
  durationMsChange: 'durationmschange',
  expectedDurationMsChange: 'expecteddurationmschange',
  emptied: 'emptied',
  encrypted: 'encrypted',
  ended: 'ended',
  error: 'error',
  interruptBegin: 'interruptbegin',
  interruptEnd: 'interruptend',
  loadedData: 'loadeddata',
  loadedMetadata: 'loadedmetadata',
  loadStart: 'loadstart',
  offline: 'offline',
  pause: 'pause',
  play: 'play',
  playing: 'playing',
  playlistItem: 'playlistItem',
  progress: 'progress',
  qualityChanged: 'qualitychanged',
  seeked: 'seeked',
  seeking: 'seeking',
  stalled: 'stalled',
  suspend: 'suspend',
  timeUpdate: 'timeupdate',
  volumeChange: 'volumechange',
  waiting: 'waiting',
  addTrack: 'addtrack'
};
module.exports = exports['default'];